import PortfoliosList from './PortfoliosList';
export default PortfoliosList;